document.addEventListener("DOMContentLoaded", () => {
  for(const [uniq, federation] of Object.entries(window.orbit.federations)) {
    if (sibStore && "setLocalData" in sibStore) {
      sibStore.setLocalData(federation, uniq);
    }
  }
});